import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuthFetch } from "shared/providers/auth/use-auth-fetch";

import { useUserPreferencesListQueryOptions } from "./use-user-preferences-list-query";

type Response = {
  permanent_knowledge: string[];
  lastUpdate: number;
};

type Params = {
  index: number;
};

export const useDeleteUserPreferencesMutation = () => {
  const fetch = useAuthFetch();
  const queryClient = useQueryClient();
  const preferencesOptions = useUserPreferencesListQueryOptions();
  return useMutation({
    mutationFn: async ({ index }: Params) => {
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/user-preferences/${index}`,
        { method: "DELETE" }
      );
      const data: Response = await response.json();

      return data;
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: preferencesOptions.queryKey,
      });
    },
  });
};
